import Slider from "react-slick";

import CustomArrow from './CustomArrow';

import i18nService from '../../../services/i18nService';

export default function CaseSelector(props) {
  let caseSlides = []
  props.cases.forEach(watchCase => {
    caseSlides.push(
      <div key={watchCase.id}
        className="Carousel-slide"
        onClick={() => props.selectCase(watchCase)}
        >
        <div
          className="Carousel-slide-image"
          style={{ backgroundImage: `url(${watchCase.production_cover})`}}
          />
        <h2 className="Carousel-slide-title">
          <span className="Carousel-slide-title-pre">{watchCase.name_pre}</span> {watchCase.name} <span className="Carousel-slide-title-post">{watchCase.name_post}</span>
        </h2>
        <div className="Carousel-slide-price-container">
          <p className="Carousel-slide-price strike-through"><small>{i18nService.translate(props.locale, 'worth')}</small> {watchCase.price_from}</p>
          <p className="Carousel-slide-price-notice"><small>{i18nService.translate(props.locale, 'included')}</small></p>
        </div>
      </div>
    )
  })

  const slickSettings = {
    dots: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction='right' />,
    prevArrow: <CustomArrow direction='left' />
  };

  return (
    <div className="CaseSelector">
      <div className="desktop-only">
        <Slider {...slickSettings} infinite={false} slidesToShow={4}>{caseSlides}</Slider>
      </div>

      <div className="mobile-only">
        <Slider {...slickSettings} infinite={true} slidesToShow={1}>{caseSlides}</Slider>
      </div>
    </div>
  )
}
